import styled from '@emotion/styled';
import { colors, ColorVariant, getRecipeColor, Icon, Stack, ToggleSwitch } from '@ui-components/neo.tax';

export const StyledSwitch = styled(ToggleSwitch)({}, ({ variant }: { variant: ColorVariant }) => ({
  color: getRecipeColor(variant, 'whiteBg').text,
}));

export const StyledIcon = styled(Icon)(
  {
    color: colors.gray[500],
  },
  ({ $bgColor }: { $bgColor?: string }) => ({
    backgroundColor: $bgColor ?? colors.gray[100],
  }),
);

export const ProjectEligibilityContainer = styled(Stack)({
  flexBasis: '0',
  flexGrow: '1',
});

export const StyledStack = styled(Stack)(
  {
    height: 80,
  },
  ({ $borderBottom, $borderTop }) => ({
    borderBottom: $borderBottom ? `1px solid ${colors.gray[200]}` : 'none',
    borderTop: $borderTop ? `1px solid ${colors.gray[200]}` : 'none',
  }),
);
